import React from 'react';
import { Helmet } from 'react-helmet-async';

import './Press.scss';
import arteuparte from '../img/press/arteuparte.png';
import artribune from '../img/press/artribune.png';
import balarm from '../img/press/balarm.png';
import brooklynStreetArt from '../img/press/brooklyn-street-art.jpg';
import cheFare from '../img/press/che-fare.png';
import exibart from '../img/press/exibart.png';
import juxtapoz from '../img/press/juxtapoz.png';
import malatinta from '../img/press/malatinta.png';
import mocu from '../img/press/mocu.png';
import primaBergamo from '../img/press/prima-bergamo.png';
import sceneContemporanee from '../img/press/scene-contemporanee.png';
import secondamano from '../img/press/secondamano.png';
import stafMagazine from '../img/press/staf-magazine.png';
import streetArtChaser from '../img/press/street-art-chaser.png';
import urbanLives from '../img/press/urban-lives.png';

export class Press extends React.Component<{}> {
  render() {
    return (
      <>
        <Helmet>
          <title>Press - Who Is NemO'S?</title>
          <meta name="theme-color" content="#faf4ef" />
        </Helmet>
        <div className="page-content press">
          <article className="quote">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.mocu.it/arti-visive/arte-contemporanea/settantadue-la-mostra-disegni-sculture-nemos-presso-studio-tape/?fbclid=IwAR0u6fHG3SdMZPT7uPIAP88cyu3GiL3smAfBFYWoDCp7OriJxauOWBKznaw"
            >
              <div className="info">
                <img alt="Mocu" src={mocu} />
                <span className="date">2021-01-23</span>
                <span className="site">Mocu</span>
                <span className="title">Settantadue: la mostra di Nemo’s presso Studio Tape</span>
              </div>
              <blockquote>
                La provocazione del mio lavoro sta nell’aver creato un’opera che per la situazione
                storica diventava importante non per il suo valore artistico o di oggetto da
                collezione, ma in quanto unico presidio di prevenzione contro l’infezione. Così ho
                prodotto settantadue saponette a forma di testa, una per ogni giorno di lockdown che
                ho vissuto, mi sono disinfettato e lavato con una di queste saponette documentando
                così lo scomparire giorno per giorno dei tratti anatomici della scultura.
              </blockquote>
            </a>
          </article>
          <article className="quote">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://www.brooklynstreetart.com/theblog/2017/02/08/nemos-bunches-heads-together-like-grapes-in-roman-suburb/#.WJtPaiPhC_t"
            >
              <div className="info">
                <img alt="Brooklyn Street Art" src={brooklynStreetArt} />
                <span className="date">2017-02-08</span>
                <span className="site">Brooklyn Street Art</span>
                <span className="title">
                  Nemo's bunches heads together like grapes in Roman suburb
                </span>
              </div>
              <blockquote>
                “In the 1930s the people who lived in via della conciliazione, a street near San
                Pietro, were displaced from the centre of Roma and forced to move to the outskirts,”
                he says, as he describes this neighborhood that has hosted collectives and movements
                of the left wing historically.
              </blockquote>
            </a>
          </article>
          <article className="quote">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.juxtapoz.com/news/street-art/who-is-nemo-s/"
            >
              <div className="info">
                <img alt="Juxtapoz" src={juxtapoz} />
                <span className="date">2017-01-10</span>
                <span className="site">Juxtapoz</span>
                <span className="title">Who is Nemo's?</span>
              </div>
              <blockquote>
                My work is divided into essential and graphic images, with a social message and made
                up characters that carry out poetic and surreal actions like characters in who knows
                which fairy tale.
              </blockquote>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.secondamanoitalia.it/vivere/lartista-dellinquietudine/?fbclid=IwAR0WIi5XWMi5XuU683v7T-VeVio_xJXEwM68WI-yUI23yTnY7TvmKOh1xh4"
            >
              <div className="info">
                <img alt="Secondamano" src={secondamano} />
                <span className="date">2020-11-16</span>
                <span className="site">Secondamano</span>
                <span className="title">L’artista dell’inquietudine</span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.che-fare.com/street-art-nemos-luogo/"
            >
              <div className="info">
                <img alt="Che Fare" src={cheFare} />
                <span className="date">2019-12-09</span>
                <span className="site">Che Fare</span>
                <span className="title">
                  Per NemO’s le opere appartengono ai luoghi in cui nascono
                </span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://www.exibart.com/notizia.asp?IDNotizia=59076&IDCategoria=45"
            >
              <div className="info">
                <img alt="Exibart" src={exibart} />
                <span className="date">2018-09-10</span>
                <span className="site">Exibart</span>
                <span className="title">Graffiti Never Die/ Nemo’s</span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://www.brooklynstreetart.com/theblog/2018/06/04/david-de-la-mano-x-nemos-collabo-in-abandoned-uruguay/"
            >
              <div className="info">
                <img alt="Brooklyn Street Art" src={brooklynStreetArt} />
                <span className="date">2018-06-04</span>
                <span className="site">Brooklyn Street Art</span>
                <span className="title">
                  David De La Mano X Nemo's collabo in abandoned Uruguay
                </span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://urbanlives.it/tag/nemos-street-art/"
            >
              <div className="info">
                <img alt="Urban Lives" src={urbanLives} />
                <span className="date">2016-01-15</span>
                <span className="site">Urban Lives</span>
                <span className="title">Nemo’s Si Mette A Nudo, Come I Suoi Personaggi</span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://www.scenecontemporanee.it/arti-visive/raccontare-la-street-art-intervista-a-nemos-1802"
            >
              <div className="info">
                <img alt="Scene Contemporanee" src={sceneContemporanee} />
                <span className="date">2015-08-21</span>
                <span className="site">Scene Contemporanee</span>
                <span className="title">Raccontare la street art. Intervista a NemO’s</span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://www.brooklynstreetart.com/theblog/2015/08/20/nemos-a-censored-penis-and-slicing-the-human-condition-in-brooklyn/#.VdlP4UvKoyt"
            >
              <div className="info">
                <img alt="Brooklyn Street Art" src={brooklynStreetArt} />
                <span className="date">2015-08-20</span>
                <span className="site">Brooklyn Street Art</span>
                <span className="title">
                  Nemo's, a censored penis, and slicing the human condition in Brooklyn
                </span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://www.bergamopost.it/chi-e/nemos-quando-larte-sui-muri-disegna-nuove-geografie-urbane/"
            >
              <div className="info">
                <img alt="Prima Bergamo" src={primaBergamo} />
                <span className="date">2015-07-26</span>
                <span className="site">Prima Bergamo</span>
                <span className="title">
                  NemO’s, quando l’arte sui muri disegna nuove geografie urbane
                </span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://stafmagazine.com/folios/nemos/"
            >
              <div className="info">
                <img alt="Staf Magazine" src={stafMagazine} />
                <span className="date">2015-04-26</span>
                <span className="site">Staf Magazine</span>
                <span className="title">NEMOS</span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://www.balarm.it/mobile/article.asp?id=13542"
            >
              <div className="info">
                <img alt="Balarm" src={balarm} />
                <span className="date">2015-01-18</span>
                <span className="site">Balarm</span>
                <span className="title">Rispondere allo sgombero con l'arte: NemO's al TMO</span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://www.artribune.com/dettaglio/evento/41588/nemos-debutto-teatrale-del-tmo/"
            >
              <div className="info">
                <img alt="Artribune" src={artribune} />
                <span className="date">2015-01-17</span>
                <span className="site">Artribune</span>
                <span className="title">Nemo’s / debutto teatrale del TMO</span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.arteuparte.com/artee/nemos-el-paso-del-tiempo-la-arbitrariedad-y-la-crudeza-del-ser-humano/"
            >
              <div className="info">
                <img alt="Arteuparte" src={arteuparte} />
                <span className="date">2014-12-18</span>
                <span className="site">Arteuparte</span>
                <span className="title">
                  NemO’s. El paso del tiempo, la arbitrariedad y la crudeza del ser humano
                </span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://lucianamarin.wordpress.com/2014/12/04/the-mystery-of-nemos-whoisnemos/"
            >
              <div className="info">
                <img alt="Street Art Chaser" src={streetArtChaser} />
                <span className="date">2014-12-04</span>
                <span className="site">Street Art Chaser</span>
                <span className="title">The mystery of NemO’s</span>
              </div>
            </a>
          </article>
          <article>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="http://www.malatintamagazine.com/nemos-el-artista-que-nos-muestra-el-paso-del-tiempo/"
            >
              <div className="info">
                <img alt="Malatinta" src={malatinta} />
                <span className="date">2014-12-01</span>
                <span className="site">Malatinta</span>
                <span className="title">NemO´s y la vulnerabilidad de la sociedad</span>
              </div>
            </a>
          </article>
        </div>
      </>
    );
  }
}
